import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

export const jwtInterceptor: HttpInterceptorFn = (request, next) => {
  const accessToken = localStorage.getItem('JWT_TOKEN');
  const isApiUrl = request.url.startsWith(environment.apiUrl);

  const publicRoutes = [
    '/api/user/request-password-reset',
    '/api/auth/token',
    '/api/user/create',
    '/api/user/registration-educators'
  ];

  const urlPath = new URL(request.url).pathname;
  const isPublicRoute = publicRoutes.includes(urlPath);

  let setHeaders: Record<string, string> = {};
  if (accessToken && isApiUrl && !isPublicRoute) {
    setHeaders = {
      ...setHeaders,
      Authorization: `Bearer ${accessToken}`
    };
  }

  request = request.clone({
    setHeaders: setHeaders
  });

  return next(request);
};
